import { mainTextColor, white } from '../constants/variables';

// Accepts a backround color, and determines an accessible text color based on its brightness

const getTextColor = bgColor => {
  // Remove the leading "#" if present
  let hex = bgColor.replace(/^#/, '');

  // Expand 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(ch => ch + ch)
      .join('');
  }

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate brightness using the YIQ formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness > 128 ? mainTextColor : white;
};

export default getTextColor;
